import type { DataGridColumnOrderState, DataGridColumnVisibilityState, TableSortingState } from '@ibsys/kit';

/** Имя таблицы списка правок в пользовательских настройках */
export const FEEDBACK_TABLE_NAME = 'expertReportFeedbackList';

/** Размер порции, запрашиваемой при прокрутке списка */
export const FEEDBACK_PAGE_SIZE = 50;

/** Колонки списка правок; id колонки — он же ключ отбора и сортировки */
export const FEEDBACK_COLUMNS = {
  conversation: 'conversationId',
  changedAt: 'changedAt',
  author: 'authorName',
  version: 'version',
  rating: 'rating',
  comment: 'comment',
  ratingPreviousValue: 'ratingPreviousValue',
  ratingValue: 'ratingValue',
  commentPreviousValue: 'commentPreviousValue',
  commentValue: 'commentValue',
  expertReport: 'expertReportName',
  // Идентификатор отличается от прежнего `blockName`: сохранённая настройка старого столбца
  // отбрасывается как настройка отсутствующего, и новый состав по умолчанию доходит до тех,
  // кто список уже настраивал
  target: 'criterion',
} as const;

/** Порядок колонок по умолчанию: сначала показанные, затем скрытые */
export const DEFAULT_FEEDBACK_COLUMN_ORDER: DataGridColumnOrderState = [
  FEEDBACK_COLUMNS.conversation,
  FEEDBACK_COLUMNS.changedAt,
  FEEDBACK_COLUMNS.author,
  FEEDBACK_COLUMNS.version,
  FEEDBACK_COLUMNS.target,
  FEEDBACK_COLUMNS.rating,
  FEEDBACK_COLUMNS.comment,
  FEEDBACK_COLUMNS.ratingPreviousValue,
  FEEDBACK_COLUMNS.ratingValue,
  FEEDBACK_COLUMNS.commentPreviousValue,
  FEEDBACK_COLUMNS.commentValue,
  FEEDBACK_COLUMNS.expertReport,
];

/** Колонки, скрытые до тех пор, пока пользователь не включит их сам */
const HIDDEN_FEEDBACK_COLUMNS: string[] = [
  FEEDBACK_COLUMNS.ratingPreviousValue,
  FEEDBACK_COLUMNS.ratingValue,
  FEEDBACK_COLUMNS.commentPreviousValue,
  FEEDBACK_COLUMNS.commentValue,
  FEEDBACK_COLUMNS.expertReport,
];

/** Видимость колонок по умолчанию — явное значение по каждой колонке списка */
export const DEFAULT_FEEDBACK_COLUMN_VISIBILITY: DataGridColumnVisibilityState = Object.fromEntries(
  DEFAULT_FEEDBACK_COLUMN_ORDER.map((columnId) => [columnId, !HIDDEN_FEEDBACK_COLUMNS.includes(columnId)]),
);

/** Порядок по умолчанию: свежие правки первыми */
export const DEFAULT_FEEDBACK_SORTING: TableSortingState = [{ id: FEEDBACK_COLUMNS.changedAt, desc: true }];
